import React, { Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay';

import ListingCardInline from '../../../../../pro/components/ListingCardInline';
import { VideoUploadPermissionBlock } from '../../../../../pro/services/contributors';
import useOpenModal from '../../../../../../hooks/useOpenModal';
import { isAlbumOwner } from '../../../../../../util/account';
import { getAsset } from '../../../../../../util/assets';
import { CONTRIBUTOR_SHARE_MODAL } from '../../../../../../constants/modals';
import { isWeddingsContent } from '../../../../../../util/album';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
    creator: PropTypes.shape({
      id: PropTypes.string,
    }),
    join_code: PropTypes.string,
  }).isRequired,
  user: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const WebGalleryVideoAlbumNullState = ({ album, user }) => {
  const openModal = useOpenModal();
  const history = useHistory();

  if (!album) {
    return null;
  }
  const startDate = album?.start_date ? new Date(album.start_date) : null;
  const endDate = album?.end_date ? new Date(album.end_date) : null;
  const startAndEndDateSameDay =
    !startDate || !endDate ? true : isSameDay(startDate, endDate);
  const dateFormat = 'MMMM do, yyyy';
  const isOwner = isAlbumOwner(user, album);
  const isWeddingsAlbum = isWeddingsContent(album);

  return (
    <Fragment>
      <div className="text-center mb-3 mt-2 web-gallery-header-container">
        <div className="web-gallery-null-state-title-wrapper">
          <p className="web-gallery-null-state-welcome">Welcome to</p>
          <h2 className="web-gallery-null-state-title"> {album.name} </h2>
          {startDate && (
            <p className="text-black text-dark text-sm">
              {format(startDate, dateFormat)}{' '}
              {endDate &&
                !startAndEndDateSameDay &&
                `- ${format(endDate, dateFormat)}`}
            </p>
          )}
        </div>

        <div className="web-gallery-null-state-copy">
          <h3 className="w-100 mb-6 grayscale-faded text-center">
            No videos here yet!
          </h3>
          <div className="null-state-listing-cards-list">
            <VideoUploadPermissionBlock entityId={album?.id}>
              <ListingCardInline
                title={
                  isOwner && isWeddingsAlbum
                    ? 'Record a Greeting'
                    : 'Record a Video'
                }
                className="photo-listing-card"
                icon={
                  <img
                    src={getAsset('/video-camera-illustration.svg')}
                    width="120"
                    alt="Record a video"
                  />
                }
                onClick={event => {
                  event.preventDefault();
                  history.push({
                    pathname: `/app/shutterbug/albums/${album?.id}/record-video`,
                    state: {
                      target: album,
                    },
                  });
                }}
                tooltip={
                  <span>Get started by recording your video greeting!</span>
                }
                tooltipId="tooltip-null-state-listing-cards-upload-photos"
              />
            </VideoUploadPermissionBlock>

            <ListingCardInline
              title="Share Event"
              className="photo-listing-card"
              icon={
                <img
                  src={getAsset('/cloud-value-illustration.svg')}
                  width="180"
                  className="mb-2"
                  alt="Invite People"
                />
              }
              onClick={event => {
                event.preventDefault();
                openModal(CONTRIBUTOR_SHARE_MODAL);
              }}
              tooltip={
                <span>
                  Share with others to view &amp; add their own videos to your
                  album!
                </span>
              }
              tooltipId="tooltip-null-state-listing-cards-invite-people"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

WebGalleryVideoAlbumNullState.prototype = propTypes;

export default WebGalleryVideoAlbumNullState;
